<script setup lang="ts">
import { __ } from '@@/bits/intl'

withDefaults(
  defineProps<{
    /**
     * Size preset.
     */
    sizePreset?: SizePreset
  }>(),
  {
    sizePreset: SizePreset.W24px,
  },
)
</script>

<script lang="ts">
enum SizePreset {
  W24px = 'W24px',
  W28px = 'W28px',
}

export { SizePreset as OzPadletCraneIconSizePreset }
export default {}
</script>

<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="padletLogoCraneIcon"
    :class="[
      'crane-icon',
      'group-active:transition-transform group-active:scale-[1.2]',

      /**
       * SIZE PRESETS
       */
      sizePreset === SizePreset.W24px && 'w-6 h-6',
      sizePreset === SizePreset.W28px && 'w-7 h-7',
    ]"
  >
    <title>{{ __('Padlet crane') }}</title>
    <path
      d="M22.44 11.7559L21.2394 9.5611C21.2394 9.5611 21.2376 9.5575 21.237 9.5557C21.2322 9.5455 21.2268 9.5359 21.2214 9.5257C21.2076 9.5011 21.1926 9.4777 21.1752 9.4555C21.1428 9.4105 21.1026 9.3697 21.0594 9.3355C21.0378 9.3181 21.015 9.3031 20.9916 9.2893C20.9556 9.2677 20.9184 9.2503 20.8794 9.2371C20.8692 9.2335 20.8602 9.2305 20.8512 9.2281C20.7936 9.2107 20.7336 9.2017 20.6724 9.2017H18.5016C18.4164 9.2017 18.3318 9.2197 18.2538 9.2533L15.5856 10.4041L13.0926 4.6123C12.9084 4.1833 12.4644 3.8905 11.9898 3.8833H11.9706C11.496 3.8905 11.0526 4.1833 10.8678 4.6111L8.36937 10.4155L4.01217 8.0137C3.86637 7.9333 3.70377 7.8907 3.54117 7.8907C3.19677 7.8907 2.87457 8.0779 2.69937 8.3791C2.52477 8.6797 2.52477 9.0403 2.69937 9.3445C2.69997 9.3475 2.70177 9.3499 2.70417 9.3517L2.91957 9.7165L8.44257 19.3549C8.44797 19.3651 8.45397 19.3753 8.45997 19.3849L8.46417 19.3915C8.72997 19.8337 9.20997 20.1163 9.75177 20.1163C9.86397 20.1163 9.97617 20.1037 10.0854 20.0791L11.9802 19.6483L13.8744 20.0791C13.9836 20.1037 14.097 20.1163 14.2092 20.1163C14.7978 20.1163 15.3144 19.7827 15.5604 19.2727L17.097 16.5907L19.8408 12.2899C19.8546 12.2971 19.8678 12.3043 19.8816 12.3109L21.282 12.9769C21.4032 13.0345 21.5316 13.0639 21.6636 13.0639C21.9738 13.0639 22.2648 12.8977 22.425 12.6283C22.5852 12.3583 22.5906 12.0319 22.4394 11.7547L22.44 11.7559ZM12.4458 4.7377C12.4758 4.7737 12.4998 4.8145 12.519 4.8589C12.4944 4.8163 12.4704 4.7761 12.4458 4.7377Z"
      fill="black"
    />
    <path
      d="M21.891 12.0552C22.0116 12.276 21.7788 12.522 21.5514 12.414L20.1504 11.7486L20.6724 9.82617L21.8904 12.0552H21.891Z"
      fill="#CED0D4"
    />
    <path
      d="M12.519 4.85808L16.404 13.8839L12.2904 14.4719L11.9808 4.50708C12.1986 4.51008 12.4278 4.64568 12.5196 4.85808H12.519Z"
      fill="#FFD54F"
    />
    <path
      d="M16.404 13.884L15.0654 18.8088C14.958 19.2816 14.487 19.578 14.0136 19.4706L11.9808 19.0092L12.2934 15.0972L16.4046 13.8846L16.404 13.884Z"
      fill="#FF833E"
    />
    <path
      d="M11.9802 4.50708L11.6676 14.4719L7.5564 13.8839L11.4414 4.85808C11.5332 4.64568 11.7624 4.51008 11.9802 4.50708Z"
      fill="#53E047"
    />
    <path
      d="M11.6676 15.0972L11.9802 19.0092L9.94741 19.4706C9.47401 19.578 9.00301 19.2816 8.89501 18.8088L7.55701 13.884L11.6682 15.0966L11.6676 15.0972Z"
      fill="#9466E8"
    />
    <path
      d="M16.9782 13.6374C17.034 13.767 17.0442 13.9116 17.007 14.0478L16.2858 16.7016L20.6724 9.82617H18.501L15.8328 10.9776L16.9776 13.6374H16.9782Z"
      fill="#FF4081"
    />
    <path
      d="M6.95401 14.0479C6.91681 13.9117 6.92701 13.7671 6.98281 13.6375L8.12161 10.9915L3.71041 8.55966C3.40381 8.39046 3.06841 8.73126 3.24241 9.03486L7.70941 16.8277L6.95401 14.0479Z"
      fill="#3992DE"
    />
  </svg>
</template>
